/**
 * 이벤트 상태 값 상수.
 * @description
 * - `OPENED`: 확인 필요 (신규 이벤트)
 * - `PROCESSING`: 처리 중
 * - `RESOLVED`: 해결됨
 */
export const EventStatus = {
  Opened: 'OPENED',
  Processing: 'PROCESSING',
  Resolved: 'RESOLVED',
} as const;

export type EventStatusType = (typeof EventStatus)[keyof typeof EventStatus];

export interface EventItem {
  endDate: string | null;
  eventId: string;
  eventStatus: EventStatusType;
  relatedServices: string[];
  startDate: string;
  title: string;
}

export interface EventListPage {
  content: EventItem[];
  limit: number;
  offset: number;
  total: number;
}

export interface ConsoleEventsResponse {
  eventList: EventListPage;
  unsolvedEventCount: number;
}

/**
 * 이벤트 코멘트 항목.
 * @description
 * - 시간순으로 기록된 상태 변경/설명 항목이다.
 * - `status`는 해당 시점의 이벤트 상태로, 타임라인 아이콘 색상에 사용한다.
 */
export interface EventCommentItem {
  comment: string;
  date: string;
  status: EventStatusType;
}

/**
 * 이벤트 상세 응답의 `relatedServices` 원소 타입.
 * @description
 * - OpenAPI 스펙은 문자열 배열이지만, 실제 API가 객체 배열을 내려주는 경우도 방어적으로 허용한다.
 */
export type RelatedServiceItem =
  | string
  | {
      name?: string;
      serviceName?: string;
      serviceStatus?: EventStatusType;
      title?: string;
    };

/**
 * 이벤트 상세 응답 모델.
 * @description
 * - OpenAPI `EventVM` 스펙 외에 실제 API가 추가로 반환하는 `region`, 코멘트의 `status`를 포함한다.
 */
export interface EventDetail {
  endDate: string | null;
  eventComments: EventCommentItem[];
  eventId: string;
  startDate: string;
  title: string;
  eventStatus?: EventStatusType;
  region?: string;
  relatedServices?: RelatedServiceItem[];
  serviceName?: string;
  type?: string;
}
